import React from "react";
import styles from "./Pagination.module.css";

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [5, 10, 25], // Matches screenshot
}: {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (pageNumber: number) => void;
  onPageSizeChange: (newSize: number) => void;
  pageSizeOptions?: number[];
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate the range (e.g., "6–10" of 20)
  const startRange =
    totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endRange = Math.min(currentPage * itemsPerPage, totalItems);

  // Handle Dropdown Change
  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onPageSizeChange(Number(e.target.value));
  };

  if (totalItems === 0) return null;

  return (
    <div className={styles.paginationContainer}>
      {/* Rows Per Page Selector */}
      <div className={styles.rowsPerPageWrapper}>
        <span className={styles.label}>Rows per page:</span>
        <div className={styles.selectWrapper}>
          <select
            className={styles.minimalSelect}
            value={itemsPerPage}
            onChange={handlePageSizeChange}
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          {/* Custom Arrow Icon (Down) */}
          <svg className={styles.selectArrow} viewBox="0 0 24 24">
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </div>
      </div>

      {/* Range Text (e.g., 6-10 of 20) */}
      <div className={styles.rangeText}>
        {startRange}–{endRange} of {totalItems}
      </div>

      {/* Navigation Icons */}
      <div className={styles.navIcons}>
        <button
          className={styles.iconButton}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous Page"
        >
          {/* Left Chevron SVG */}
          <svg viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>

        <button
          className={styles.iconButton}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next Page"
        >
          {/* Right Chevron SVG */}
          <svg viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
